import AbstractConfig from "../../../core/config/AbstractConfig";
import DashboardTrendDefinition from "./DashboardTrendDefinition";
import DashboardRCCEDefinition from "./DashboardRCCEDefinition";

export default class DashboardConfig extends AbstractConfig {
    constructor(progressGameModel) {
        super();

        this._progressGameModel = progressGameModel;

        this._savedDashboardConfig = null;
        this._latestRCCEMovieClip = null;
    }

    /**
     * @returns {Array<DashboardTrendDefinition>}
     */
    getDashboardTrendDefinition(dashboardName) {

        const dashboardObj = this.getGerericDashboard(dashboardName);

        const dashboardDefinitions = [];
        for (const [key, value] of Object.entries(dashboardObj)) {
            const dashboardDefinition = new DashboardTrendDefinition(
                key,
                value?.column,
                value?.localizedLabel,
                value?.greenTrendOnPositiveData,
            );
            dashboardDefinitions.push(dashboardDefinition);
        }

        return dashboardDefinitions;
    }

    /**
     * @returns {Array<DashboardRCCEDefinition>}
     */
    getDashboardRCCEDefinition() {

        const dashboardObj = this.getGerericDashboard("RCCE");

        const dashboardDefinitions = [];
        for (const [key, value] of Object.entries(dashboardObj)) {
            const dashboardDefinition = new DashboardRCCEDefinition(
                key,
                value?.week,
            );
            dashboardDefinitions.push(dashboardDefinition);
        }

        return dashboardDefinitions;
    }

    getRCCEMovieClipPerWeek(weekNumber) {
        const config = this.getSaveConfig();
        if(this._latestRCCEMovieClip != config.RCCE.movieClipPerWeek[weekNumber]) {
            this._latestRCCEMovieClip = config.RCCE.movieClipPerWeek[weekNumber];
            this._progressGameModel.updatedDashboardRCCE = true;
        }
        return this._latestRCCEMovieClip;
    }

    getSaveConfig() {
        if (this._savedDashboardConfig == null) {
            this._savedDashboardConfig = this.getValue('dashboard');
            return this._savedDashboardConfig;
        } else {
            return this._savedDashboardConfig;
        }
    }

    getGerericDashboard(dashboardName) {
        const dashboard = this.getSaveConfig();

        return dashboard[dashboardName];
    }

    get dashboardEpi() {
        return this.getDashboardTrendDefinition("epi");
    }

    get dashboardHealthSystems() {
        return this.getDashboardTrendDefinition("healthSystems");
    }

    get dashboardRCCE() {
        return this.getDashboardRCCEDefinition();
    }
}
